
import { initAniState } from './ani-state.js';
import { initAniVisibilityAuto, initDirectionalVisibilityGate } from './visibility.js';
import { initAniMacros } from './ani-macros.js';
import { initAniTransitions } from './ani-transitions.js';
import { initAniDebug } from './ani-debug.js';






export function initGeneralAnimations() {
  return [
    initAniState(),
    initAniVisibilityAuto(),
    initAniMacros(),
    initAniTransitions(),
    initAniDebug(),
    initDirectionalVisibilityGate(),

  ];
}
 